import { ChangeDetectionStrategy, Component, inject, Injector } from '@angular/core';

import { AskTemplatesDataService } from '@core/ask-hr-templates-logic';
import type { AskPredefinedTemplate } from '@core/ask-hr-templates-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { ProsemirrorBasicConfig } from '@core/prosemirror-legacy/webapp';
import {
  DialogBodyComponent,
  DialogComponent,
  DialogHeaderComponent,
} from '@core/user-interface-legacy';

import { AddNewTemplateComponent } from '../add-new-template/add-new-template.component';
import { AskTemplatesDialogService } from '../ask-templates-dialog.service';
import { SetupBannerComponent } from '../setup-banner/setup-banner.component';

@Component({
  selector: 'ask-hr-add-new-template-dialog',
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    TranslatePipe,
    SetupBannerComponent,
    AddNewTemplateComponent,
  ],
  templateUrl: './add-new-template-dialog.component.html',
  styleUrl: './add-new-template-dialog.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddNewTemplateDialogComponent extends DialogComponent<void, void> {
  private readonly injector = inject(Injector);
  private readonly templatesDataService = inject(AskTemplatesDataService);
  private readonly askTemplatesDialogService = inject(AskTemplatesDialogService);

  protected readonly ProsemirrorBasicConfig = ProsemirrorBasicConfig;

  public ngOnInit(): void {
    this.templatesDataService.loadPredefinedTemplates();
  }

  protected openTemplateEdit(template: AskPredefinedTemplate | null) {
    this.dialogRef.close();
    this.askTemplatesDialogService.openCreateTemplateDialog(this.injector, template);
  }
}
